<template>
  <router-view />
  <van-tabbar v-show="isShow" v-model="active">
    <!-- 家长角色 -->
    <template v-if="roleNum == 1">
      <van-tabbar-item icon="home-o" to="/myCourese">首页</van-tabbar-item>
      <van-tabbar-item icon="calendar-o" to="/attend">考勤</van-tabbar-item>
      <van-tabbar-item icon="user-o" to="/user">我的</van-tabbar-item>
    </template>
    <!-- 老师角色（含 type 6 巡课老师） -->
    <template v-else-if="roleNum == 2 || roleNum == 3 || roleNum == 6">
      <!-- type 6 巡课老师：首页 tab 即巡课管理 -->
      <van-tabbar-item v-if="roleNum == 6" icon="home-o" to="/dutyInspect">巡课</van-tabbar-item>
      <van-tabbar-item v-else icon="home-o" to="/teacherHome">排课</van-tabbar-item>
      <van-tabbar-item icon="calendar-o" to="/teacherAttend">出勤</van-tabbar-item>
      <van-tabbar-item icon="user-o" to="/user">我的</van-tabbar-item>
    </template>
  </van-tabbar>
</template>

<script>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";

export default {
  setup() {
    const active = ref(0);
    const isShow = ref(false);
    const roleNum = ref(Number(sessionStorage.getItem("role")) || 0);
    const route = useRoute();

    // 家长显示Tab的路径
    const parentPaths = ["/myCourese", "/attend", "/user"];
    // 老师显示Tab的路径
    const teacherPaths = ["/teacherHome", "/teacherAttend", "/schedule", "/user"];
    // 巡课老师（type 6）显示Tab的路径：首页为巡课管理
    const dutyTeacherPaths = ["/dutyInspect", "/teacherAttend", "/user"];

    // 家长Tab索引映射
    const parentTabIndex = { "/myCourese": 0, "/attend": 1, "/user": 2 };
    // 老师Tab索引映射
    const teacherTabIndex = {
      "/teacherHome": 0,
      "/teacherAttend": 1,
      "/user": 2,
      "/schedule": 0,
    };
    // 巡课老师Tab索引映射（与模板顺序对应：巡课=0/出勤=1/我的=2）
    const dutyTeacherTabIndex = {
      "/dutyInspect": 0,
      "/teacherAttend": 1,
      "/user": 2,
    };

    // 更新Tab显示和高亮的函数
    function updateTab() {
      // 每次都重新读取 role，防止登录后角色变化但页面未刷新
      roleNum.value = Number(sessionStorage.getItem("role")) || 0;

      let path = route.fullPath;
      let isTeacher = roleNum.value == 2 || roleNum.value == 3 || roleNum.value == 6;

      if (roleNum.value == 6) {
        // 巡课老师
        isShow.value = dutyTeacherPaths.some((p) => path.includes(p));
        if (dutyTeacherTabIndex[path] !== undefined) {
          active.value = dutyTeacherTabIndex[path];
        }
      } else if (!isTeacher && roleNum.value == 1) {
        // 家长
        isShow.value = parentPaths.some((p) => path.includes(p));
        if (parentTabIndex[path] !== undefined) {
          active.value = parentTabIndex[path];
        }
      } else if (isTeacher) {
        // 老师
        isShow.value = teacherPaths.some((p) => path.includes(p));
        if (teacherTabIndex[path] !== undefined) {
          active.value = teacherTabIndex[path];
        }
      } else {
        isShow.value = false;
      }
    }

    // 监听路由变化，immediate 确保首次加载也执行
    watch(() => route.fullPath, updateTab, { immediate: true });

    return {
      active,
      isShow,
      roleNum,
    };
  },
};
</script>

<style lang="less">
:root {
  --color-primary: #52c1b2;
  --color-primary-dark: #3aa89a;
  --color-primary-light: #e8f8f6;
  --color-primary-lighter: #e6fffb;
  --color-success: #52c41a;
  --color-warning: #ff976a;
  --color-danger: #ee0a24;
  --color-info: #1989fa;
}

/* 覆盖 Vant 默认主色 */
:root:root {
  --van-primary-color: #52c1b2;
  --van-primary-color-light: #e8f8f6;
  --van-primary-color-dark: #3aa89a;
  --van-primary-color-background: #e8f8f6;
  --van-tabbar-item-active-color: #52c1b2;
  --van-nav-bar-icon-color: #52c1b2;
  --van-nav-bar-text-color: #52c1b2;
  --van-tag-primary-color: #52c1b2;
  --van-button-primary-background: #52c1b2;
  --van-button-primary-border-color: #52c1b2;
  --van-calendar-selected-day-background: #52c1b2;
}

body {
  background-color: #f2f2f2;
}

.footer {
  background-color: white;
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 0;
  font-size: 12px;
  color: gray;
}

/* 课程类型标签 type=4=其他（紫），Vant 无内置紫色，自定义类型 */
.van-tag--other {
  color: #fff;
  background-color: #8e44ad;
  border-color: #8e44ad;
}
.van-tag--other.van-tag--plain {
  color: #8e44ad;
  background-color: #f3e9fb;
  border-color: #8e44ad;
}
</style>
